// lang文件夹下的index.js 
// zh, en 分别为两种语言文件
import { createI18n } from 'vue-i18n';
import { Local as vLocal } from "@/locales/vantLocale";
import { Local as mLocal } from "@/locales/momentLocale";
import en from './en.json';
import tl from './tl.json';

let savedLocale = localStorage.getItem('i18n') || navigator.browserLanguage || navigator.language;
let langList = ['en-US', 'tl-PH']
if (langList.indexOf(savedLocale) < 0) {
  savedLocale = langList[0]
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式，设为 false
  // globalInjection: true,
  locale: savedLocale, // 默认语言
  fallbackLocale: 'en-US', // 回退语言
  // allowComposition: true, // you need to specify that!
  messages: {
    'en-US': en,
    'tl-PH': tl
  }
});

Local(savedLocale);

export function Local(mylang) {
  vLocal(mylang);
  mLocal(mylang);
}

export default i18n;